import { useAllSurveyAreasPreviewLazyQuery } from "generated/graphql"
import { useEffect } from "react"

export const useAllSurveyAreasPreview = (dcId: string) => {
  const [getData, response] = useAllSurveyAreasPreviewLazyQuery()

  useEffect(() => {
    if (dcId && parseInt(dcId)) {
      getData({
        variables: {
          filter: {
            distributionCentreIds: [dcId],
          },
        },
      })
    }
  }, [getData, dcId])

  return response
}
